<template>
    <div class="col-md-12">
        <WppContactsTable ref="contactsTable" @changed="$refs.groupsTable.refresh()"></WppContactsTable>
        <WppGroupsTable   ref="groupsTable"   @changed="$refs.contactsTable.refresh()"></WppGroupsTable>
    </div>
</template>

<script>
import WppContactsTable from './WppContactsTable.vue';
import WppGroupsTable from './WppGroupsTable.vue';

export default {
    name: "ConfigSolicitations",
    components: {
        WppContactsTable,
        WppGroupsTable,
    },
    data() {
        return {}
    },
    created() {},
    methods: {
    }
}
</script>